import { addStyles } from 'ethcss'
import { color, colors, IStyles, palette } from 'theme'

export const buttonStyles: IStyles = {
    button: {
        appearance: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 14px',
        lineHeight: '18px',
        cursor: 'pointer',
        transition: 'background-color 150ms ease, border-color 150ms ease, opacity 150ms ease',

        '&:disabled': {
            opacity: 0.55,
            cursor: 'default',
        },
    },
    size_s: {
        borderRadius: 8,
        fontSize: 14,
        minHeight: 34,
    },
    size_m: {
        borderRadius: 12,
        fontSize: 16,
        minHeight: 44,
    },
    size_l: {
        borderRadius: 16,
        fontSize: 16,
        minHeight: 56,
    },
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        flexShrink: 0,
    },
    iconRight: {
        flexDirection: 'row-reverse',
    },
    'icon-right': {
        marginLeft: 8,
    },
    'icon-left': {
        marginRight: 8,
    },
    iconOnly: {
        padding: 0,
        lineHeight: 0,
        flexShrink: 0,
    },
    iconOnly_s: {
        width: 34,
        height: 34,
        minWidth: 34,
        minHeight: 34,
    },
    iconOnly_m: {
        width: 44,
        height: 44,
        minWidth: 44,
        minHeight: 44,
    },
    iconOnly_l: {
        width: 56,
        height: 56,
        minWidth: 56,
        minHeight: 56,
    },
    fillBrand: {
        backgroundColor: palette.brandBlue.main,
        color: palette.white.main,
        border: 'none',
    },
    fillBlack: {
        backgroundColor: palette.neutral.main,
        color: palette.white.main,
        border: 'none',
    },
    default: {
        border: `1px solid ${color.borderDarkPrimary}`,
        color: color.fontDarkUltraHigh,
        '&:hover': {
            backgroundColor: color.bgWhiteSecondary,
            borderColor: color.borderDarkSecondary,
            color: color.fontDarkHigh,
        },
        '&:active': {
            backgroundColor: color.bgWhiteSecondary,
            borderColor: color.borderDarkPrimary,
            color: color.fontDarkUltraHigh,
        },
    },
}

addStyles(buttonStyles)
